export const CREATED = 'CREATED';
export const CONNECTING = 'CONNECTING';
export const IN_PROGRESS = 'IN_PROGRESS';
export const ENDED = 'ENDED';
export const DISCONNECTED = 'DISCONNECTED';
export const UNANSWERED = 'UNANSWERED';
export const DECLINED = 'DECLINED';
export const PENDING = 'PENDING';
export const DROPPED = 'DROPPED';

export const upcomingConsultationStatuses = [DECLINED, UNANSWERED, CONNECTING];
export const inConversationStatuses = [IN_PROGRESS, ENDED, DISCONNECTED];
export const inProgressConversationStatuses = [CONNECTING, IN_PROGRESS];
export const inProgressStatuses = [IN_PROGRESS, CREATED, CONNECTING];
export const endedConversationStatuses = [ENDED, DISCONNECTED, DECLINED, DROPPED, UNANSWERED];

export const UPCOMING = 'UPCOMING';
export const OVERDUE = 'OVERDUE';

